export default "__VITE_ASSET__l259HCDN__"